import React, { Component } from 'react';
import { Field, reduxForm, Form, reset, change } from 'redux-form';
import Button from 'material-ui/Button';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';

import { CircularProgress } from 'material-ui/Progress';

import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import Layout from '../Layout';

import renderDatePicker from '../../helpers/RenderDatePicker';
import renderSelectField from '../../helpers/RenderSelectField';
import validationHelper from '../../helpers/ValidationHelper';

import search from '../../actions/search';
import getPerson from '../../actions/getPerson';
import searchByAttribute from '../../actions/searchByAttribute';
import { getPortfolioAlerts, clearPortfolioAlerts } from '../../actions/getPortfolioAlerts';
import { getPortfolioAudit, clearPortfolioAudits } from '../../actions/getPortfolioAudit';

import PostFrame from './PostFrame';
import AlertsReportPostFrame from './AlertReportPostFrame';
import ReactSelect from "../../helpers/ReactSelect";

const styles = theme => ({
    card: {
        display: 'flex',
        boxShadow: 'none',
        justifyContent: 'center'
    },
    content: {
        display: 'flex'
    },
    paperStyle: {
        width: '70%',
        height: '70%',
        display: 'inline-block',
        margin: 20,
        marginTop: '13vh',
        maxWidth: '1075px',
        minHeight: '476px'
    },
    buttonStyle: {
        marginTop: '10%',
    },
    marginStyle: {
        margin: 8
    },
    textField: {
        width: 200,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        marginTop: '3.2%'
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    marginTop3: {
        marginTop: '3%'
    },
    circularProgress: {
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 0',
    }
});

const validate = (values) => {
    const errors = validationHelper.validateRequired(['customer', 'selectReport', 'portfolioId', 'startDate', 'endDate'], values);
    if (values.startDate && values.endDate && !validationHelper.validateDates(values.startDate, values.endDate)) {
        errors.endDate = 'End Date cannot precede the Start Date';
    }
    return errors;
};

class ReportManager extends Component {
    state = {
        userType: 'normal',
        customerId: '',
        portfolios: [],
        reportFetching: false,
        reportFetched: false,
        selectedPortfolio: '',
        selectedCustomer: '',
        selectedCustomerId: '',
        selectedCustomerName: '',
        customers: []
    };

    componentDidMount() {
        this.props.actions.getCustomers(this.props.data.config, this);
    }

    getCustomerPortfolio = (event) => {
        const selectedCustomerId = event ? event.value : '';
        const selectedCustomerName = event ? event.label : '';

        if (selectedCustomerId) {
            this.props.actions.getPortfolioData(selectedCustomerId, this.props.data.config, this);
        }

        this.props.dispatch(change('ReportManagerForm', 'customer', selectedCustomerId));

        this.setState({ selectedCustomerId, selectedCustomerName });
    };

    handleSave = (event) => {
        this.setState({
            open: true,
            selectedPortfolio: this.state.portfolios.find(x => x.portfolioId === event.portfolioId).name,
            selectedCustomer: this.state.selectedCustomerName,
        }, () => {
            switch (event.selectReport) {
                case 1:
                    this.props.actions.getPortfolioAudit(event, this.props.data.config, this);
                    break;
                case 2:
                    this.props.actions.getPortfolioAlerts(event, this.props.data.config, this);
                    break;
                default:
                    break;
            }
        });
    };

    hideModal() {
        this.setState({ open: false, selectedCustomerId: "", selectedCustomerName: "" });
        this.props.dispatch(reset('ReportManagerForm'));
        this.props.actions.clearPortfolioAlerts();
        this.props.actions.clearPortfolioAudits();
    }

    render() {
        let progress;
        const { classes, handleSubmit } = this.props;
        const portfolioOption = [];
        const customerOptions = [];
        if (this.state.customers && this.state.customers.action && this.state.customers.action.payload && this.state.customers.action.payload.data) {
            this.state.customers.action.payload.data.items.forEach((customer) => {
                if (customer.product && customer.product.includes('vxc') && (customer.customerId === this.state.customerId || this.state.userType === 'Auto Tec')) {
                    customerOptions.push({ key: customer.customerId, value: customer.customerId, label: customer.name });
                }
            });
        }
        console.log('Customer Options: ', customerOptions)
        this.state.portfolios.forEach((portfolio) => {
            portfolioOption.push(<MenuItem key={portfolio.portfolioId} value={portfolio.portfolioId}>{portfolio.name}</MenuItem>)
        });

        progress = (
        <Button
            variant="raised"
            disabled={!this.props.valid || !this.props.dirty}
            style={this.props.valid && this.props.dirty ? { background: '#002053' } : { background: '#ddd' }}
            type="submit"
            >Submit
        </Button>);

        if (this.state.displayRunReportButton) {
            progress = (
            <Button
                variant="raised"
                disabled={!this.props.valid}
                style={this.props.valid ? { background: '#002053' } : { background: '#ddd' }}
                type="submit"
                >Submit
            </Button>);
        } else if (this.state.reportFetching) {
            progress = <div align="center"><CircularProgress size={75} /></div>;
        }
        return (
            <Layout className="App" showMenu menuTitle="Reporting" leftTitle="Report Manager" rightTitle="Submit File" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
                <Paper className={classes.paperStyle}>
                {
                    this.state.fetching ?
                    <CircularProgress className={classes.circularProgress} size={75} /> :
                    <Form className={classes.form} onSubmit={handleSubmit(this.handleSave)}>
                    <p className="mandatory-msg">* - Denotes required fields</p>
                        <Card className={classes.card}>
                            <CardContent className={classes.content}>
                                <ReactSelect
                                    name="customer"
                                    label="*Customer"
                                    placeholder="*Customer"
                                    options={customerOptions}
                                    onChange={this.getCustomerPortfolio}
                                    value={this.state.selectedCustomerId}
                                    style={{ width: 200, backgroundColor: 'transparent', cursor: 'pointer' }}
                                    dispatch={this.props.dispatch}
                                    formName={"ReportManagerForm"}
                                />
                            </CardContent>
                        </Card>
                        <Card className={classes.card}>
                            <CardContent className={classes.content}>
                                <Field name="portfolioId" component={renderSelectField} label="*Portfolio" className={classes.textField} divClassName={classes.formControl} >
                                    {portfolioOption}
                                </Field>
                                <Field name="selectReport" component={renderSelectField} label="*Select a Report" className={classes.textField} divClassName={classes.formControl} >
                                    <MenuItem value={1}>Audit</MenuItem>
                                    <MenuItem value={2}>Alert</MenuItem>
                                </Field>
                                <Field name="startDate" component={renderDatePicker} label="*Start Date" className={classes.textField} divClassName={classes.marginStyle} />
                                <Field name="endDate" component={renderDatePicker} label="*End Date" className={classes.textField} divClassName={classes.marginStyle} />
                            </CardContent>
                        </Card>
                        <div className={classes.buttonStyle}>
                            {progress}
                        </div>
                        {
                            this.state.reportFetched && this.props.data.portfolioAlerts.report && this.props.data.portfolioAlerts.report.alerts &&
                            <AlertsReportPostFrame
                                report={this.props.data.portfolioAlerts.report.alerts}
                                displayDialog={this.state.open}
                                hideModal={o => this.hideModal()}
                                selectedCustomer={this.state.selectedCustomer}
                                selectedPortfolio={this.state.selectedPortfolio}
                            />
                        }
                        {
                            this.state.reportFetched && this.props.data.portfolioAudit.report && this.props.data.portfolioAudit.report.audits &&
                            <PostFrame
                                report={this.props.data.portfolioAudit.report.audits}
                                displayDialog={this.state.open}
                                hideModal={o => this.hideModal()}
                                selectedCustomer={this.state.selectedCustomer}
                                selectedPortfolio={this.state.selectedPortfolio}
                            />
                        }
                    </Form>
                }

                </Paper>
            </Layout>
        );
    }
}

ReportManager.propTypes = {
    classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
    data: {
        customers: state.customers,
        config: state.config.config,
        person: state.person.person,
        login: state.login.login,
        portfolioAlerts: state.portfolioAlerts,
        portfolioAudit: state.portfolioAudit
    }
});

const mapDispatchToProps = dispatch => ({
    actions: {
        getCustomers: (config, self) => {
            self.setState({ fetching: true });
            dispatch(getPerson(null, self.props.data.login.sub, self.props.data.config)).then((result) => {
                let customerId = '';
                result.action.payload.data.person.locations.forEach((location) => {
                    if (location.locationId === localStorage.locationId) {
                        customerId = location.customerId;
                    }
                });
                self.setState({ customerId });
                dispatch(search('customers', 0, self.props.match.params.id, config)).then((customers) => {
                    self.setState({ customers, fetching: false });
                    customers.action.payload.data.items.forEach((customer) => {
                        if (customer.customerId === customerId && customer.name === 'AutoTec Test') {
                            self.setState({ userType: 'Auto Tec' });
                        }
                    });
                });
            });
        },
        getPortfolioData: (customerId, config, self) => {
            self.setState({ fetching: true });
            dispatch(change('ReportManagerForm', 'portfolioId', ''))
            dispatch(searchByAttribute('portfolios', 0, 'customerId', customerId, config)).then((result1) => {
                self.setState({ portfolios: result1.value.data.items, fetching: false });
            });
        },
        getPortfolioAlerts: (data, config, self) => {
            self.setState({ reportFetching: true });
            dispatch(getPortfolioAlerts(data.portfolioId, data.startDate, data.endDate, config)).then((response) => {
                if (response.action.type === 'PORTFOLIO_ALERTS_FETCH_FULFILLED') {
                    self.setState({ reportFetching: false, reportFetched: true });
                }
            });
        },
        getPortfolioAudit: (data, config, self) => {
            self.setState({ reportFetching: true });
            dispatch(getPortfolioAudit(data.portfolioId, data.startDate, data.endDate, config)).then((response) => {
                if (response.action.type === 'PORTFOLIO_AUDIT_FETCH_FULFILLED') {
                    self.setState({ reportFetching: false, reportFetched: true });
                }
            });
        },
        clearPortfolioAlerts: () => {
            dispatch(clearPortfolioAlerts());
        },
        clearPortfolioAudits: () => {
            dispatch(clearPortfolioAudits());
        }
    }
});

const ConnectedReportManager = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportManager);

export default withStyles(styles, { withTheme: true })(reduxForm({ form: 'ReportManagerForm', validate })(ConnectedReportManager));


// WEBPACK FOOTER //
// ./src/components/VXC/ReportManager.js